import React, {forwardRef} from 'react';
import {InputAdornment} from '@material-ui/core';
import {Close, Search} from '@epic-ui/icons';
import {ClearButton, StyledSearchInput} from './AutocompleteList.styles';
import {InputBaseProps} from '@material-ui/core/InputBase/InputBase';

export interface SearchInputProps extends InputBaseProps {
    search: string;
    onReset: () => void;
}

const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
    ({search, onReset, ...inputProps}: SearchInputProps, ref) => {
        return (
            <StyledSearchInput
                ref={ref}
                fullWidth
                {...inputProps}
                startAdornment={
                    <InputAdornment position="start">
                        <Search />
                    </InputAdornment>
                }
                endAdornment={
                    search ? (
                        <InputAdornment position="end">
                            <ClearButton onClick={onReset} variant="text" color="primary">
                                <Close />
                            </ClearButton>
                        </InputAdornment>
                    ) : null
                }
            />
        );
    }
);

export default SearchInput;
